// 백엔드 URL 결정 우선순위:
// 1. 환경변수 REACT_APP_BACKEND_URL (예: http://192.168.0.31:3001)
// 2. location.host 기반 동적 결정

// api 명세: http://192.168.0.31:3001/ 접근
const getBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  if (typeof window !== "undefined") {
    const host = window.location.host;
    const protocol = window.location.protocol;

    // 로컬 환경 감지 (localhost 또는 127.0.0.1 또는 내부 IP)
    if (
      host.includes("localhost") ||
      host.includes("127.0.0.1") ||
      host.startsWith("192.168.") ||
      host.startsWith("10.")
    ) {
      // 로컬 환경: 백엔드 포트 직접 접근
      return "http://localhost:3001";
    }

    // Cloudflare 터널 또는 원격 환경: /api 경로 사용
    return `${protocol}//${host}/api`;
  }
  // 서버 사이드 렌더링 시 기본값
  return "http://localhost:3001";
};

export const CONFIG = {
  BACKEND_URL: getBackendUrl(),
  POLLING_INTERVAL: 2000, // 2초
  ROBOT: {
    deviceId: "one_perla_omron_ld90_01",
    name: "물류로봇 1",
  },
  // TODO: 나중에 요청시 바꿔줘야함 (실제 연동시),
  POI_LIST: [
    { name: "101동 1-3라인으로 이동", poiId: "101dong 1-3line" },
    { name: "101동 4-5라인으로 이동", poiId: "101dong 4-5line" },
    { name: "102동 1-3라인으로 이동", poiId: "102dong 1-3line" },
    { name: "102동 4-5라인으로 이동", poiId: "102dong 4-5line" },
    { name: "103동으로 이동", poiId: "103" },
    { name: "104동으로 이동", poiId: "104" },
    { name: "105동으로 이동", poiId: "105" },
    { name: "106동으로 이동", poiId: "106" },
    { name: "107동으로 이동", poiId: "107" },
    { name: "108동 1-2라인으로 이동", poiId: "108dong 1-2line" },
    { name: "108동 3-4라인으로 이동", poiId: "108dong 3-4line" },
    { name: "시작위치로 이동", poiId: "START" },
    { name: "대기위치로 이동", poiId: "HOME" },
    { name: "101동 1-3라인에서 언도킹", poiId: "CartUnDock_101dong 1-3line" },
    { name: "101동 4-5라인에서 언도킹", poiId: "CartUnDock_101dong 4-5line" },
    { name: "102동 1-3라인에서 언도킹", poiId: "CartUnDock_102dong 1-3line" },
    { name: "102동 4-5라인에서 언도킹", poiId: "CartUnDock_102dong 4-5line" },
    { name: "103동에서 언도킹", poiId: "CartUnDock_103" },
    { name: "104동에서 언도킹", poiId: "CartUnDock_104" },
    { name: "105동에서 언도킹", poiId: "CartUnDock_105" },
    { name: "106동에서 언도킹", poiId: "CartUnDock_106" },
    { name: "107동에서 언도킹", poiId: "CartUnDock_107" },
    { name: "108동 1-2라인에서 언도킹", poiId: "CartUnDock_108dong 1-2line" },
    { name: "108동 3-4라인에서 언도킹", poiId: "CartUnDock_108dong 3-4line" },
    { name: "시작위치에서 언도킹", poiId: "CartUnDock_START" },
    { name: "대기위치에서 언도킹", poiId: "CartUnDock_HOME" },
  ],
  PERSPECTIVE_MAPPING_RAW: {
    // 원본 srcPts (로봇 좌표계 기준)
    srcPts: [
      { x: -54609, y: 79110 },
      { x: -54395, y: 172709 },
      { x: 21370, y: 173067 },
      { x: 16807, y: 71331 },
    ],
    dstPts: [
      { x: 720, y: 588 },
      { x: 1880, y: 595 },
      { x: 1875, y: 1510 },
      { x: 625, y: 1460 },
    ],
  },
  transformSrcPoint: (pt) => {
    // srcPts 변환 함수: srcPts가 dstPts 기준으로 -90도 회전 + Y 반전된 상태를
    // 로봇 좌표계로 역변환
    // 변환: (x, y) -> (y, x)
    // 다른 변환이 필요하면 아래 옵션 사용:
    // return { x: -pt.y, y: pt.x };        // 반시계 90도 회전
    // return { x: pt.y, y: -pt.x };        // 시계 90도 회전
    // return { x: -pt.y, y: -pt.x };       // 90도 회전 + X, Y 부호 반전
    // return { x: pt.x, y: -pt.y };        // Y 부호만 반전
    return { x: pt.y, y: pt.x };
  },

  // 로봇 좌표 변환 함수: transformSrcPoint와 동일한 변환 적용
  transformRobotPoint: (pt) => {
    return { x: pt.y, y: pt.x };
  },

  // 변환된 PERSPECTIVE_MAPPING (로봇 좌표를 그대로 사용)
  get PERSPECTIVE_MAPPING() {
    return {
      srcPts: this.PERSPECTIVE_MAPPING_RAW.srcPts.map((pt) =>
        this.transformSrcPoint(pt),
      ),
      dstPts: this.PERSPECTIVE_MAPPING_RAW.dstPts,
    };
  },
  MAP_IMAGE: "/assets/map.png",
  // 원본 이미지 크기 (입력할것)
  MAP_ORIGINAL_SIZE: { width: 2464, height: 1728 },
  MARKER_RENDER_EASING: 0.1, // 부드러운 이동을 위한 easing 값 (0.1~0.5 권장)

  // WebSocket URL (location.host 기반)
  // 로컬 환경: localhost:3001 직접 접근
  // Cloudflare 터널: /ws 경로로 라우팅
  getWebSocketUrl: () => {
    if (process.env.REACT_APP_WEBSOCKET_URL) {
      return process.env.REACT_APP_WEBSOCKET_URL;
    }

    if (process.env.REACT_APP_BACKEND_URL) {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const wsUrl = backendUrl
        .replace(/^https:/, "wss:")
        .replace(/^http:/, "ws:");
      return `${wsUrl}/ws`;
    }

    if (typeof window !== "undefined") {
      const host = window.location.host;
      const protocol = window.location.protocol;

      // 로컬 환경 감지
      if (
        host.includes("localhost") ||
        host.includes("127.0.0.1") ||
        host.startsWith("192.168.") ||
        host.startsWith("10.")
      ) {
        // 로컬 환경: 백엔드 포트 직접 접근
        return "ws://localhost:3001/ws";
      }

      // Cloudflare 터널 또는 원격 환경: /ws 경로 사용
      const wsProtocol = protocol === "https:" ? "wss:" : "ws:";
      return `${wsProtocol}//${host}/ws`;
    }
    return "ws://localhost:3001/ws";
  },
};
